module.exports = __webpack_public_path__ + "img/regulatory-two.6ff289e9.png";